export const matchesInterviewReadinessFilters = ({
  enrollment,
  filter,
  selectedBatch,
  searchTerm,
  getReadinessStatus
}) => {
  if (filter && filter !== 'all') {
    const status = getReadinessStatus(enrollment.id).status;
    if (filter === 'ready' && status !== 'ready') return false;
    if (filter === 'not-ready' && status !== 'not-ready') return false;
    if (filter === 'no-data' && status !== 'no-data') return false;
  }

  if (selectedBatch && enrollment.batch?.id !== parseInt(selectedBatch, 10)) return false;

  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    const studentName = enrollment.student?.fullName?.toLowerCase() || '';
    const batchName = enrollment.batch?.batchName?.toLowerCase() || '';
    const email = enrollment.student?.emailAddress?.toLowerCase() || '';
    const phone = enrollment.student?.phoneNumber?.toLowerCase() || '';
    const domain = enrollment.student?.domain?.domainName?.toLowerCase() || '';
    const studentId = String(enrollment.student?.id || '').toLowerCase();

    if (
      !studentName.includes(term) &&
      !batchName.includes(term) &&
      !email.includes(term) &&
      !phone.includes(term) &&
      !domain.includes(term) &&
      !studentId.includes(term)
    ) {
      return false;
    }
  }

  return true;
};
